package pl.decks.personal.pages.blog._2026

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initZeropositivePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/2026/zeropositive.md", FrontMatterElement.Builder { addScalar("heroImage", "/images/blog/2026/zero-plus/diag_test.png"); addScalar("title", "Runs in my veins"); addScalar("description", "No cure. But mostly harmless."); addScalar("date", "2026-06-18"); addList("tags") { addScalar("diagnosis"); addScalar("habits"); addScalar("code"); addScalar("compound-effects"); }; }))
}

@Page("/blog/2026/zero-positive")
@Layout(".components.layouts.blog.BlogPostLayout")
@Composable
fun ZeropositivePage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("I'm sick.")
        }
        org.jetbrains.compose.web.dom.Text(" Some would even say - wicked. I have a 0+ syndrome, and it manifests in a variety of flavors and symptoms.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For one, I presort my laundry at the moment of disposal, so it is less painful to stuff it into the washing machine. I also organize it and pair the socks right when hanging it on the drying rack.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The plates, bowls and cutlery have their predefined space clusters in the dishwasher and unloading it is just a few handful scoops.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I commit often. Nowadays even more, e.g. just before letting an LLM give a shot at a task, so it is easier to review (and maybe revert) what it has changed in the code base. I use descriptive names. Clean the data at read. Ever heard ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://lexi-lambda.github.io/blog/2019/11/05/parse-don-t-validate/") {
            org.jetbrains.compose.web.dom.Text("\"Parse, don't validate\"")
        }
        org.jetbrains.compose.web.dom.Text("? It's a surprisingly zero positive statement.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Didn't need to play a single poker hand to know never to fold, when you can pass.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There is a real price to pay. The burden is more free time and less decision fatigue. Sometimes, I overanalyze most unimportant parts of a daily routine in pursuit of minuscule gains. Or have to deal with the hustle of rewiring life-long habits.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I've done some research. Many suffer this, to a greater or lesser degree, without knowing. A lot of people notice something is going on, when they become masters in a domain. The highest level in anything is a game of compounding 0+ moves.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The syndrome is not listed in the ICD-10, nor in the DSM-5. Consulting a psychologist might place it on the scales for OCD, ADHD or autism, depending on what the tint is. Mostly harmless, it probably won't earn its entry.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This means that introspection is the only tool available for now. I know that when I'm heads down on some problem (and I am always pondering something), everyday chores slip as an afterthought. I don't want to grow with filth either.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Being 0+ has a unique shape for everyone, and for the time being, you have to be your own diagnostician. Do you cringe at how suboptimally people around you approach the simplest activities? Get surprised looks at how you do things? Those are good predictors.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Zero positiveness is not about ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://courtneybowers.substack.com/p/a-crash-course-in-anti-productivity") {
            org.jetbrains.compose.web.dom.Text("boiling the frog")
        }
        org.jetbrains.compose.web.dom.Text(" with unfit hacks and productivity tricks. The solutions you come up with or decide to employ must emerge from who you are and align with your personality, not contradict it. Eventually you probably will have to ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://workbrighter.co/first-pancake-productivity-vs-eat-the-frog/") {
            org.jetbrains.compose.web.dom.Text("eat the frog")
        }
        org.jetbrains.compose.web.dom.Text(", but it is for you to decide if you fancy it for supper rather than breakfast.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("P.S. Turns out the symptoms tend to worsen once someone acknowledges the condition and finds themselves giving it a second thought. ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("I'm sorry.")
        }
    }
}
